import axios from "axios"

import BrandIndexService from "@/services/cis-brandindex.service";

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

export default class makeDtSetMarketOverview {
    constructor (category, st_dt, en_dt) {
        this.sel_category = category
        this.st_dt = st_dt
        this.en_dt = en_dt

        this.majorClsList = []
    }

    async initialize() {
        await this.getMajorClsList()
    }

    async getMajorClsList() {
        // 선택한 카테고리의 대분류 정보를 획득한다. (데이터 셋 생성 시 대분류 필터 적용 용도)
        const majorClasses = await BrandIndexService.getmajorclasslist({
            ctgSq: this.sel_category
        }, source);

        if (majorClasses.data.success) {
            if (majorClasses.data.data.length > 0) {
                this.majorClsList = []

                for (const item of majorClasses.data.data)
                    this.majorClsList.push(item.title)
            }  
        }
    }

    async run() {
        var resDataset = [];        
        
        // 전체 (대분류 필터 적용 안함)
        const catTableResp = await BrandIndexService.getmarketoverview({
            mode: "month", 
            st_dt: this.st_dt, 
            en_dt: this.en_dt, 
            ctgSq: this.sel_category, 
            selMajor: null, 
            selMiddle: null
        }, source);

        if (catTableResp && catTableResp.status === 200) {
            var totChartCat = [];
            var brnChartCat = [];
            var totChartData = [];
            var brnChartData = [];

            if (catTableResp.data.data[0] != null) {
                var total = catTableResp.data.data[0].total.split(',')
                var branded = catTableResp.data.data[0].branded.split(',')
                var nonbranded = catTableResp.data.data[0].nonbranded.split(',')

                totChartData.push({
                    brand: 'TOTAL',
                    data: total,
                })

                brnChartData.push({
                    brand: 'NONBRANDED',
                    data: nonbranded,
                })

                brnChartData.push({
                    brand: 'BRANDED',
                    data: branded,
                })

                totChartCat = catTableResp.data.data[0].date.split(',')
                brnChartCat = catTableResp.data.data[0].date.split(',')
            }

            resDataset.push({'sheet_nm': 'Total_전체', 'data': totChartData, 'cat': totChartCat})
            resDataset.push({'sheet_nm': 'Branded & Nonbranded_전체', 'data': brnChartData, 'cat': brnChartCat})
        }

        const comResp = await BrandIndexService.getallbyperiod({
            mode: "month", 
            index: 'competition', 
            st_dt: this.st_dt, 
            en_dt: this.en_dt, 
            ctgSq: this.sel_category, 
            selMajor: null, 
            selMiddle: null
        }, source);

        if (comResp && comResp.status === 200) {
            var comChartCat = [];
            var comChartData = [];

            for(const item of comResp.data.data) {               
                comChartData.push({
                    brand: item.brand,
                    data: item.competition.split(','),
                })

                if (comChartCat.length == 0) {
                    comChartCat = item.date.split(',')
                }
            }  

            resDataset.push({'sheet_nm': 'Competition_전체', 'data': comChartData, 'cat': comChartCat})
        }

        if (this.majorClsList.length > 0) {
            for (const major of this.majorClsList) {
                // 전체 (대분류 필터 적용 안함)
                const catTableResp = await BrandIndexService.getmarketoverview({
                    mode: "month", 
                    st_dt: this.st_dt, 
                    en_dt: this.en_dt, 
                    ctgSq: this.sel_category, 
                    selMajor: major, 
                    selMiddle: null
                }, source);

                if (catTableResp && catTableResp.status === 200) {
                    var totChartCat = [];
                    var brnChartCat = [];
                    var totChartData = [];
                    var brnChartData = [];

                    if (catTableResp.data.data[0] != null) {
                        var total = catTableResp.data.data[0].total.split(',')
                        var branded = catTableResp.data.data[0].branded.split(',')
                        var nonbranded = catTableResp.data.data[0].nonbranded.split(',')

                        totChartData.push({
                            brand: 'TOTAL',
                            data: total,
                        })

                        brnChartData.push({
                            brand: 'NONBRANDED',
                            data: nonbranded,
                        })

                        brnChartData.push({
                            brand: 'BRANDED',
                            data: branded,
                        })

                        totChartCat = catTableResp.data.data[0].date.split(',')
                        brnChartCat = catTableResp.data.data[0].date.split(',')
                    }

                    resDataset.push({'sheet_nm': `Total_${major}`, 'data': totChartData, 'cat': totChartCat})
                    resDataset.push({'sheet_nm': `Branded & Nonbranded_${major}`, 'data': brnChartData, 'cat': brnChartCat})
                }

                const comResp = await BrandIndexService.getallbyperiod({
                    mode: "month", 
                    index: 'competition', 
                    st_dt: this.st_dt, 
                    en_dt: this.en_dt, 
                    ctgSq: this.sel_category, 
                    selMajor: major, 
                    selMiddle: null
                }, source);

                if (comResp && comResp.status === 200) {
                    var comChartCat = [];
                    var comChartData = [];

                    for(const item of comResp.data.data) {               
                        comChartData.push({
                            brand: item.brand,
                            data: item.competition.split(','),
                        })

                        if (comChartCat.length == 0) {
                            comChartCat = item.date.split(',')
                        }
                    }  

                    resDataset.push({'sheet_nm': `Competition_${major}`, 'data': comChartData, 'cat': comChartCat})
                }
            }
        }

        return resDataset
    }
}